import { useState } from 'react';
import Layout from '../components/Layout';
import KmzToShpTool from '../components/tools/KmzToShpTool';
import AttachmentExportTool from '../components/tools/AttachmentExportTool';

const TOOLS = [
  { key: 'convert', label: 'Convert', Component: KmzToShpTool },
  { key: 'attachments', label: 'Attachment Export', Component: AttachmentExportTool },
];

export default function ToolsPage() {
  const [active, setActive] = useState('convert');
  const Active = TOOLS.find((t) => t.key === active).Component;

  return (
    <Layout>
      <div className="max-w-6xl mx-auto space-y-6">
        <div>
          <h1 className="text-2xl font-black text-white tracking-widest uppercase">Tools</h1>
        </div>

        <div className="flex gap-2 border-b" style={{ borderColor: '#1e3a5f' }}>
          {TOOLS.map((t) => (
            <button
              key={t.key}
              onClick={() => setActive(t.key)}
              className="px-4 py-2 text-sm font-bold uppercase tracking-wide transition border-b-2 -mb-px"
              style={{
                color: active === t.key ? '#c9a84c' : '#9ca3af',
                borderColor: active === t.key ? '#c9a84c' : 'transparent',
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        <Active />
      </div>
    </Layout>
  );
}
